import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5.09 9.88v2h10v-2h-10zm5-9a10 10 0 10-.01 20 10 10 0 000-20zm0 18a8.01 8.01 0 010-16 8.01 8.01 0 010 16z" fill="#15257A" /></svg>);